export default __webpack_public_path__ + "static/media/melody-of-nature-main-6672.17b59781.mp3";